import { apiCall } from './generated/gqlClient';

const createSubscriptionAsAnonymousApiRequest = async request => {
  const mutation = `
    mutation createSubscriptionAsAnonymous($classId: Int!, $sessions: [Int]!, $email: String!) {
      createSubscriptionAsAnonymous(classId: $classId, sessions: $sessions, email: $email) {
        id
        message
        success
        amount
        amountCents
        clientSecret
        stripeAccount
      }
    }
  `;

  return apiCall({ query: mutation, variables: request });
};

const cancelSubscriptionApiRequest = async subscriptionId => {
  const mutation = `
    mutation cancelSubscription($subscriptionId: Int!) {
      cancelSubscription(subscriptionId: $subscriptionId) {
        success
        message
        id
      }
    }
  `;

  return apiCall({ query: mutation, variables: { subscriptionId } });
};

const cancelSubscriptionSessionApiRequest = async (subscriptionId, sessionId) => {
  const mutation = `
    mutation cancelSubscriptionSession($subscriptionId: Int!, $sessionId: Int!) {
      cancelSubscriptionSession(subscriptionId: $subscriptionId, sessionId: $sessionId) {
        success
        message
        id
      }
    }
  `;

  return apiCall({ query: mutation, variables: { subscriptionId, sessionId } });
};

const getSubscriptionsBySessionIdApiRequst = async sessionId => {
  const query = `
    query getSubscriptionsBySession($sessionId: Int!) {
      getSubscriptionsBySession(sessionId: $sessionId) {
        id
        providerId
        serviceId
        classId
        total
        status
        email
        code
        presence
        sessions {
          id
          status
        }
        user {
          id
          name
          firstname
          lastname
          email
          timezone
        }
        visitatore {
          id
          name
          firstname
          lastname
          email
        }
        visitatore {
          id
          name
          firstname
          lastname
          email
        }
        userInfo {
          firstname
          lastname
          email
          phone
        }
        order {
          id
        }
      }
    }
  `;
  return apiCall({ query, variables: { sessionId } });
};

const getCanceledSubscriptionsBySessionApiRequest = async sessionId => {
  const query = `
    query getCanceledSubscriptionsBySession($sessionId: Int!) {
      getCanceledSubscriptionsBySession(sessionId: $sessionId) {
        id
        providerId
        serviceId
        classId
        total
        status
        email
        code
        cancelled
        cancelledBy
        sessions {
          id
          status
        }
        user {
          id
          name
          firstname
          lastname
          email
          timezone
        }
        visitatore {
          id
          name
          firstname
          lastname
          email
        }
        visitatore {
          id
          name
          firstname
          lastname
          email
        }
        userInfo {
          firstname
          lastname
          email
          phone
        }
        order {
          id
        }
      }
    }
  `;
  return apiCall({ query, variables: { sessionId } });
};

const getSubscriptionPriceApiRequest = async request => {
  const query = `
    query getSubscriptionPrice($request: SubscriptionPriceRequest!) {
      getSubscriptionPrice(request: $request) {
        price
        priceWithoutDiscount
      }
    }
  `;
  return apiCall({ query, variables: request });
};

export {
  cancelSubscriptionApiRequest,
  cancelSubscriptionSessionApiRequest,
  createSubscriptionAsAnonymousApiRequest,
  getCanceledSubscriptionsBySessionApiRequest,
  getSubscriptionPriceApiRequest,
  getSubscriptionsBySessionIdApiRequst,
};
